import { CacheItem } from '../store/schema/CacheItem';
import { CacheDescriptor } from '../store/schema/CacheDescriptor';
import { ItemCache } from '../store/schema/ItemCache';

export function selectItemById<T extends CacheItem, U extends CacheDescriptor>(
    store: ItemCache<T, U>,
    itemId: string
): T | undefined {
    return store.items.get(itemId);
}
